'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _string = require('./utils/string');

var _client = require('./constants/client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (endpoint) {
  var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _client.UNKNOWN_CLIENT;
  var deviceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


  var headers = {};
  var sessionCid = (0, _string.randomUniqueHash)();
  var deviceCid = deviceId ? deviceId.substr(0, 6) : '';

  return {
    setHeaders: function setHeaders(new_headers) {
      headers = new_headers;
    },
    fetch: function (_fetch) {
      function fetch(_x3) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (query) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var queryName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};


      var requestCid = (0, _string.randomUniqueHash)();
      var cid = '' + (deviceCid ? 'd:' + deviceCid + '-' : '') + ('s:' + sessionCid + '-') + ('r:' + requestCid);

      var options = {
        method: 'POST',
        headers: _extends({
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, _i18next2.default.languages && _i18next2.default.languages[0] ? { 'Accept-Language': _i18next2.default.languages[0] } : {}, {
          cid: cid
        }, headers, additionalHeaders),
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      };

      var graphqlEndpoint = endpoint + '/' + clientId + '/' + cid;
      if (queryName) {
        graphqlEndpoint += '/' + queryName;
      }

      var responseCid = void 0;
      return fetch(graphqlEndpoint, options).then(function (res) {
        responseCid = res.headers.get('cid');
        return res.json();
      })
      // We are not going to send back to the caller the cid that was generated
      // before making the request, but the one returned with the api response,
      // just to ensure that it was correctly considered by the api.
      .then(function (json) {
        return _extends({}, json, { cid: responseCid });
      });
    })
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/api.js
// module id = 428
// module chunks = 0